/**
 * @file   src\components\MainMenu.tsx
 * @brief  Menu component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { pageURLs } from '../utils/pageUrls';
import { Nav, NavDropdown, Link, useState, useNavigate, useEffect, React } from '../utils/thirdpartyComponents';
import { getFromLocalStorage } from '../utils/helper';
import { CompanyApi } from '../utils/apiUrls';
import axios from "../config/axiosConfig";
import { MessageToaster } from '../utils/toastUtil';
import Cookies from 'js-cookie';


export interface NavigationState {
    origin: string;
}

const CWOMainMenu = (props: any) => {
    const shouldFetchSetting = props?.shouldFetchSetting !== false;
    const navigationState: NavigationState = { origin: 'CWOMainMenu' };
    const toaster = new MessageToaster();
    const [isMultilocationReportRequired,setIsMultilocationReportRequired] = useState(false);
    const [isPaxEnabled, setIsPaxEnabled] = useState(false);
    

    const [activeLink, setActiveLink] = useState<string>(props.active_menu); // Default active link

    const navigate = useNavigate()

    // On change of prop ,rerendering is done.
    useEffect(() => {
        setActiveLink(props.active_menu);
        const isAuthenticated = Cookies.get('accessToken')
         if (isAuthenticated && shouldFetchSetting) {
        fetchSetting()
        fetchPaxSettings()
         }
        // const storageData = getFromLocalStorage('CARWASH_OWNER_DATA');
        // let paymentAdded = getFromLocalStorage('CARWASH_OWNER_PAYMENTDATA_ADDED');
        // paymentAdded = (paymentAdded && paymentAdded === true) ? true : false;
        // const userInfo = storageData && storageData !== null ? storageData : null;
        // const customerPaymentMethodId = (userInfo !== null ) ? userInfo?.CustomerPaymentMethodId : '';
        // const isAuthenticated = userInfo !== null && Cookies.get('accessToken') !== '';
        // const allowedPages = ['/'+pageURLs.my_profile, '/'+pageURLs.dashboard]
        // if(isAuthenticated && !allowedPages.includes(location.pathname)  && !customerPaymentMethodId && !paymentAdded) {
        //    toaster.toastError("Please enter your payment information to start using the app.");
        //    navigate('/'+pageURLs.my_profile+'?tab=paymentinfo')
        // }
    }, [props.active_menu, shouldFetchSetting])

    const handleLinkClick = (url: string) => {
        setActiveLink(url)
        navigate(url, {
            state: { origin: 'CWOMainMenu' }
        })
    }

    const fetchSetting = async () => {
          try {
            const res = await axios.get(CompanyApi.GET_MULTILOCATION_REPORT_SETTINGS);
            if (res?.data?.error === 0 && res.data?.data?.hasMultipleLocationFeature !== undefined) {
              setIsMultilocationReportRequired(res.data.data.hasMultipleLocationFeature === 1);
            } else {
            //   toaster.toastError('Failed to load car info settings');
            }
          } catch (err) {
            // toaster.toastError('Error fetching car info settings');
          } finally {
            // setLoading(false);
          }
        };

        const fetchPaxSettings = async () => {
            try {
              const res = await axios.get(CompanyApi.GET_COMPANY_STATUS_SETTINGS);
              if (res?.data?.error === 0 && res.data?.data?.isPaxEnabled !== undefined) {
                setIsPaxEnabled(res.data.data.isPaxEnabled === true);
              }
            } catch (err) {
              // toaster.toastError('Error fetching car info settings');
            } finally {
              // setLoading(false);
            }
          };

    const storageData = getFromLocalStorage('CARWASH_OWNER_DATA');
    const userInfo = storageData && storageData !== null ? storageData : null;

    // Check if current page is a report page
    const isReportPage = activeLink === "reports"
    //  ||
    //     location.pathname === `/${pageURLs.membership_monthly_report}` 
      
    return (
        <div className="d-flex nav-items sm-hide">
            <Link
                to={`/${pageURLs.carwash_locations}`}
                state={navigationState as any}

                className={activeLink === "manage-car-wash-locations" ? 'f-medium active' : 'f-medium'}
                onClick={() => handleLinkClick(`/${pageURLs.carwash_locations}`)}>Manage Car Wash Locations
            </Link>
            <Link state={navigationState as any}
                className={activeLink === "manage-users" ? 'f-medium active' : 'f-medium'}
                to={`/${pageURLs.manage_users}`} >Manage Users</Link>
            <Link
                to={`/${pageURLs.manage_subscriptions}`}
                className={activeLink === "manage-subscriptions" ? 'f-medium active' : 'f-medium'}
                onClick={() => handleLinkClick(`/${pageURLs.manage_subscriptions}`)}>Manage Subscriptions
            </Link>
            {!(userInfo?.userTypeId === 4 && userInfo?.permissionType === 2)
                && <>
                    <Link
                        to={`/${pageURLs.lpr_device_listing}`}
                        className={activeLink === "lpr-device-listing" ? 'f-medium active' : 'f-medium'}
                        onClick={() => handleLinkClick(`/${pageURLs.lpr_device_listing}`)}>Manage LPR Devices
                    </Link>
                    {/* <Link to={"#"} className='f-medium' onClick={() => alert("Not Implemented.")}> Reports</Link> */}
                    <Link to={`/${pageURLs.order_history}`} state={navigationState as any}
                        className={activeLink === "hardware" ? 'f-medium active' : 'f-medium'}>Hardware</Link>
                    <Nav>
                        <div className={isReportPage ? 'f-medium active nav-item' : 'f-medium nav-item'}>
                            <NavDropdown
                                title="Reports"
                                align="end"
                            >
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.revenue_reports}`)}>Revenue Reports</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.revenue_summary_report}`)}>Revenue Summary Report</NavDropdown.Item>
                            {isPaxEnabled ? <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.pax_revenue_reports}`)}>Pax Revenue Report</NavDropdown.Item> : ""}
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.transaction_history}`)}>Transaction History</NavDropdown.Item>
                            {isMultilocationReportRequired ? <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.multilocation_usage_reports}`)}>Multi Location Usage Report</NavDropdown.Item>:""}
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.userconversion_reports}`)}>User Conversion Report</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.campaign_reports}`)}>Campaign Codes Report</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.monthly_single_purchase_report}`)}>Monthly Single Purchases Report</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.monthly_membership_purchase_report}`)}>Monthly Membership Purchase Report</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.membership_monthly_report}`)}>Membership Monthly Report</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.user_activity_report}`)}>User Activity</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.user_visit_details_report}`)}>User Visit Details</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.family_fleet_plan}`)}>Family Fleet Plan</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={() => navigate(`/${pageURLs.membership_report}`)}>Membership Data Report</NavDropdown.Item>

                            
                            </NavDropdown>
                        </div>
                    </Nav>
                </>
            }

        </div >
    );
};
export default CWOMainMenu;
